import { MomentUtils } from "./date";

export namespace Utils {

    export const Moment = MomentUtils;

}